import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { RestApi } from '../../../shared/RestApi/restApi';

interface vaultobjectattribute {
  statusMessage: any;
  error: boolean;
  data: any;
}

@Injectable({
  providedIn: 'root'
})
export class VaultobjectattributeserviceService {

  private headers = new HttpHeaders({ "Content-Type": "application/json" });

  constructor(
    private http: HttpClient,
    private snackBar: MatSnackBar,
    private restAPI: RestApi,
  ) { }

  retrieveobjectattributes(dnsId){
    return this.http.get<vaultobjectattribute>(this.restAPI.RETRIEVE_OBJECTATTRIBUTES+"/"+"SingleObjectExtraction"+"/"+dnsId, { headers: this.headers })
  }
  checktableexists(value){
    return this.http.get<vaultobjectattribute>(this.restAPI.CHECKTABLE_EXISTS+"/"+value, { headers: this.headers })
  }

  retrieveobjectlabels(){
    return this.http.get<vaultobjectattribute>(this.restAPI.RETRIEVEOBJECTLABELBYDNSIDANDSOURCE,{ headers: this.headers })
  }

  insertobjectattributes(objectattributes,method,vaultDnsname){
       return this.http.post<vaultobjectattribute>(this.restAPI.INSERT_OBJECTATTRIBUTES+"/" + method+"/"+vaultDnsname, JSON.stringify(objectattributes), { headers: this.headers })
  }

  databasename(dnsNames){
    console.log(dnsNames);
    return this.http.get<vaultobjectattribute>(this.restAPI.DATABASE_NAMES+"/"+dnsNames, { headers: this.headers })
  }

  insertedname(){
    return this.http.get<vaultobjectattribute>(this.restAPI.RETRIEVENAMEDROPDOWN_URL+"/"+"SingleObjectExtraction", { headers: this.headers })
  }

  retrieveInsertData(name){
    console.log(name);
    return this.http.get<vaultobjectattribute>(this.restAPI.RETRIEVE_DATA_BY_NAME +"/" + name, { headers: this.headers })
  }

    retrieveobjectsByDnsidforObjectRelationship(dnsId){
    return this.http.get<vaultobjectattribute>(this.restAPI.RETRIEVEOBJECTSFROMOBJECTMETADATA+"/"+dnsId,{ headers: this.headers })
  }

  }
